import $ from 'jquery';
import jQuery from 'jquery';

import 'bootstrap';

import 'select2';
import 'jquery-ui-dist/jquery-ui.js';

import { initZelftestAdmin } from "./inc/zelftest-admin";
import { initZelftest } from "./inc/zelftest";
import { initResearchScanAdmin } from "./inc/research-scan-admin";
import { initResearchScan } from "./inc/research-scan";
import { initMenu } from "./inc/menu";
import { initYouTube } from "./inc/youtube";
import { initCurriculum } from "./inc/curriculum";
import { initSearchBox } from "./inc/search";
import { initLeerwijzer } from "./inc/leerwijzer";
import { initAnalytics } from "./inc/google-tags";
import { initTracker } from "./inc/tracker";
import { initSectionSelection } from "./inc/section-selection";
import { initMailchimpSubscriptionForm } from "./inc/mailchimp-subscription-form";
import { initBanner } from "./inc/banner";
import { initManagerScan } from "./inc/manager-scan";
import { initPersonaScan } from "./inc/persona-scan";
import { initAdvancedSearch } from "./inc/advanced_search";
import { initMonthSlider } from "./inc/month-slider";
import { initGoogleMaps } from "./inc/googlemaps";
import { initCharts } from "./inc/charts";

jQuery.fn.scrollTo = function (elem, speed, correction) {
    correction = correction || 0;
    const scrollTop = $(this).scrollTop();
    const thisOffset = $(this).offset();
    const elemOffset = $(elem).offset();
    if(!scrollTop||!thisOffset||!elemOffset) {
        return this;
    }
    $(this).animate({
        scrollTop: scrollTop - thisOffset.top + elemOffset.top - correction
    }, speed == undefined ? 500 : speed);
    return this;
};

export function init() {
    //
    // checkBoxChecked();

    tweakGridSystem();

    initZelftest();

    initZelftestAdmin();

    initResearchScanAdmin();

    initResearchScan();

    setSelectedColor();

    initMenu();

    initYouTube();

    initGoogleMaps();

    initSideMenu();

    initLeerwijzer();

    initSearchBox();

    initCurriculum();

    checkBoxChecked();

    initAnalytics();

    initTracker();

    initSectionSelection();

    initMailchimpSubscriptionForm();

    initCharts();

    initBanner();

    initManagerScan();

    initPersonaScan();

    initAdvancedSearch();

    initMonthSlider();

}

function tweakGridSystem() {

    $(".wrapper>h2, .wrapper>h3, .wrapper>h4, .wrapper>p").addClass("container");

}

function checkBoxChecked() {
    $(".research-scan .form-check, .digicoach .form-check").each(function (idx_check, obj_check) {
        var $this = $(this);
        $this.on("click", function () {
            var checked = !$this.hasClass('check');
            $this.toggleClass("check", checked);
            $this.find("input").prop('checked', checked);
        });
    });

    $(".research-scan .form-radio, .digicoach .form-radio").on("click", function () {
        var $this = $(this);
        $this.parent().find(".form-radio").each(function () {
            var _$this = $(this);
            _$this.removeClass("check");
            _$this.find("input").prop('checked', '');
        });
        var checked = !$this.hasClass('check');
        $this.toggleClass("check", checked);
        $this.find("input").prop('checked', checked);
    });

}


function initSideMenu() {
    $(".menu .year").each(function (index, obj) {
        var $this = $(this);
        $(".menu .year:first").addClass("open");
        $(".year .months:first").addClass("check");
        $this.find(">a").on("click", function (e) {
            e.preventDefault();
            var checked = !$this.find(".months").hasClass('check');
            var titleChecked = !$this.hasClass('open');
            $this.find(".months").toggleClass("check", checked);
            $this.toggleClass("open", titleChecked);
            $this.find(".months").find("input").prop('checked', checked);
        });
    });
}

function setSelectedColor() {
    $("#selectcolor").change(function () {
        var color = $("option:selected", this).attr("class");
        $("#selectcolor").attr("class", color ?? '');
    });
}
